import React, { useEffect, useState } from "react";
import { Flex, IconButton, Input } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { AppThunkDispatch } from "../../../../../../../store";
import { SmallAddIcon } from "@chakra-ui/icons";
import {
  TalesEvent,
  TalesProgramma,
} from "../../../../../../../utils/types/TalesProgramma";
import { editProgramma } from "../../../../../../../store/programma/actions/edit";

interface Props {
  programma: TalesProgramma;
}
export default function NewEventForm({ programma }: Props) {
  const [newEvento, setNewEvento] = useState<TalesEvent>({
    title: "",
    details: [],
    show: true,
  });
  useEffect(() => {}, [newEvento]);

  const dispatch = useDispatch<AppThunkDispatch>();

  const handleSubmit = (e: React.MouseEvent<HTMLElement>) => {
    if (newEvento.title !== "") {
      let newProgramma = { ...programma };
      newProgramma.events = [...newProgramma.events, newEvento];

      dispatch(editProgramma(newProgramma));
    }

    setNewEvento({ title: "", details: [], show: true });
  };

  return (
    <Flex my="10px">
      <Input
        id="eventTitle"
        type="text"
        placeholder="Nuova area *"
        onChange={(val) =>
          setNewEvento({ ...newEvento, title: val.target.value })
        }
        value={newEvento.title}
        mr="10px"
      />
      <IconButton
        isRound={true}
        aria-label="Aggiungi"
        isDisabled={newEvento.title === ""}
        variant="solid"
        icon={<SmallAddIcon />}
        colorScheme="green"
        onClick={handleSubmit}
      />
    </Flex>
  );
}
